/** Nyafaz Reels — FFmpeg render stack (separate API port). */

const NATURALS_NYAFAZ_REELS = '/naturals/nyafaz-reels';
const NYAFZ_EP_NYAFAZ_REELS = '/nyafaz-ep/nyafaz-reels';

/** Active product prefix: /naturals vs /nyafaz-ep (from current URL). */
export function resolveNyafazReelsBase() {
  if (typeof window !== 'undefined') {
    const path = window.location.pathname || '';
    if (path.startsWith('/nyafaz-ep/') || path === '/nyafaz-ep') {
      return NYAFZ_EP_NYAFAZ_REELS;
    }
  }
  return NATURALS_NYAFAZ_REELS;
}

export function resolveNyafazReelsLogin() {
  return `${resolveNyafazReelsBase()}/login`;
}

/** @deprecated prefer resolveNyafazReelsBase() at runtime */
export const NYAFAZ_REELS_BASE = NATURALS_NYAFAZ_REELS;
/** @deprecated prefer resolveNyafazReelsLogin() at runtime */
export const NYAFAZ_REELS_LOGIN = `${NATURALS_NYAFAZ_REELS}/login`;

export function nyafazReelsPath(...parts) {
  const base = resolveNyafazReelsBase();
  const suffix = parts
    .filter((p) => p != null && String(p).length)
    .map((p) => String(p).replace(/^\/+|\/+$/g, ''))
    .join('/');
  return suffix ? `${base}/${suffix}` : base;
}
